/**
 * Created by frank.law on 11/16/17.
 */
import React from 'react';
import '../../../css/login.css';
import {Control} from 'react-redux-form';
import PropTypes from 'prop-types';

class PasswordField extends React.Component {

    onChange(event) {
        const {onChangeFunc} = this.props;
        onChangeFunc(event.target.value);
    }

    render() {
        const ControlPassword = Control.password;
        const {label, fieldId, placeholder, isError, autoFocus} = this.props;
        let passwordFieldStyle = "wdc-form-textinput";
        passwordFieldStyle += (isError) ? " wdc-form-error" : "";

        return (
            <div className="wdc-form-field-wrapper">
                <label className="wdc-form-label wdc-form-label-required">{label}</label>
                <div className="wdc-form-field">
                    <ControlPassword autoFocus={autoFocus} aria-label={label} model={'.' + fieldId} placeholder={placeholder} className={passwordFieldStyle}  id={fieldId} onChange={this.onChange.bind(this)} />
                </div>
            </div>
        );
    }
}

PasswordField.propTypes = {
  label: PropTypes.string,
  onChangeFunc: PropTypes.func,
  fieldId: PropTypes.string,
  placeholder: PropTypes.string,
  isError: PropTypes.bool,
  autoFocus: PropTypes.bool
};

export default PasswordField;
